import { useState, useEffect } from "react";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#050505]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 font-heading text-base tracking-tight"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_landing-lab-16/artifacts/bypk4f2i_New%20logo%201.jpg"
            alt="Peak One Partners"
            className="h-9 w-9 object-cover rounded-sm"
          />
          <span className="font-semibold">Peak One Partners</span>
        </a>

        <nav className="hidden md:flex items-center gap-9 text-sm text-white/70">
          <button
            data-testid="nav-how"
            onClick={() => scrollTo("how")}
            className="hover:text-white transition-colors"
          >
            How it works
          </button>
          <button
            data-testid="nav-founder"
            onClick={() => scrollTo("founder")}
            className="hover:text-white transition-colors"
          >
            Founder
          </button>
          <button
            data-testid="nav-faq"
            onClick={() => scrollTo("faq")}
            className="hover:text-white transition-colors"
          >
            FAQ
          </button>
        </nav>

        <button
          data-testid="nav-cta"
          onClick={() => scrollTo("audit")}
          className="hidden sm:inline-flex items-center gap-2 bg-[#00E5FF] text-black font-medium hover:bg-[#00B8CC] transition-colors px-5 py-2.5 text-sm uppercase tracking-widest"
        >
          Get my scorecard
          <span aria-hidden>→</span>
        </button>
      </div>
    </header>
  );
}
